import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbsTagbadgeComponent } from './abs-tagbadge.component'

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [AbsTagbadgeComponent],
  exports: [AbsTagbadgeComponent]
})
export class AbsTagbadgeModule { }
